export default __webpack_public_path__ + "static/media/18- Spotify.af9647ec.png";